import axios from "axios";
import Config from "../../../config";

const v2_actionRevokeInviteLink = (chatId) => axios({
    method: "post",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}/invite-link/revoke`
});

export default v2_actionRevokeInviteLink;
